import {mapActions, mapGetters, mapMutations} from 'vuex';

export default {
    components:{
        Header: () => import('@/components/header/index.vue'),
        leftBar: () => import('@/components/left-bar/index.vue'),
        Table: () => import('@/components/table/list/index.vue'),
        TableOptions: () => import('@/components/table/options/index.vue'),
        popup: () => import('@/components/popups/contacts/user/index.vue'),
        pagination: () => import('@/components/pagination/index.vue'),
    },
    data(){
      return{
          // Статичні визначення полів: перекладні підписи — labelKey,
          // сам `label` обчислюється в computed fields (залежить від локалі).
          fieldDefs:[
              {
                  key: 'id',
                  label: 'id'
              },
              {
                  key: 'name',
                  labelKey: 'contactsUsers.name'
              },
              {
                  key: 'login',
                  labelKey: 'contactsUsers.login'
              },
              {
                  key: 'user_group_id',
                  labelKey: 'contactsUsers.group'
              },
              {
                  key: 'department',
                  labelKey: 'contactsUsers.department'
              },
              {
                  key: 'email',
                  label: 'Email'
              },
              {
                  key: 'description',
                  labelKey: 'contactsUsers.description'
              },
          ],
          items:[],
          selectedItem: null,
          showPopup: false
      }
    },
    computed:{
        fields() {
            return this.fieldDefs.map(field => field.labelKey
                ? { ...field, label: this.$t(field.labelKey) }
                : field);
        },
        ...mapGetters({
          menuHide:'config/menuHide',
          usersGroup:'contacts/usersGroup',
          users:'contacts/users'
      })
    },
    watch:{
        users(e){
            this.items = []
            e.map(item=>{
                let resultGroup = this.usersGroup.data.filter(itemGroup => itemGroup.id === item.user_group_id)
                resultGroup = resultGroup[0];
                let departmentList = '';
                let maxStringLength = false
                if(item.departments.length){
                    item.departments.map(itemDepartment =>{
                        if(departmentList.length < 32) {
                            departmentList += itemDepartment.title + ', '
                        }else if(departmentList.length > 32 && !maxStringLength){
                            departmentList.slice(32)
                            departmentList += '....'
                            maxStringLength = true;
                        }
                    })
                }
                this.items.push({
                    id:item.id,
                    name: item.name,
                    title: item.name,
                    login: item.login,
                    user_group_id: resultGroup.title,
                    email: item.email,
                    description: item.description,
                    department: departmentList,
                });
            })
            this.res = e;
        },
    },
    created() {
        this.getUsersGroup().then(()=>{
            this.getUsers();
        })
    },
    methods:{
        getSearchInfo(data){ 
            if(data.query){
                this.getUsers({[data.type]: data.query});
            }else{
                this.getUsers();
            }
        },
        getAllItemsInTable(){
            this.selectedItem = this.items;
            this.$refs.tableComponent.getAllItemsInTable();
        },
        changePopup(item){
            this.changeUser(item.id)
            this.showPopup = true;
        },
        selectItem(item){
            if(item.length){
                this.selectedItem = item;
            }else{
                this.selectedItem = null;
            }
        },
        sendUser(form){
            this.postSignUp(form).then(res=>{
                if(res.status){
                    this.getUsers();
                    this.$toasted.success(this.$t('toasts.user_added'),{
                        duration : 3000
                    });
                    this.showPopup = false;
                }else{
                    if (res.data && res.data.errors) {
                        let key
                        for(key in res.data.errors){
                            this.$toasted.error(res.data.errors[key],{
                                duration : 3000
                            });
                        }
                    } else if (res.data && res.data.message) {
                        this.$toasted.error(res.data.message,{
                            duration : 3000
                        });
                    }
                }
            })
        },
        removeItem(id){
            this.removeUser(id).then(res=>{
                if(res.status){
                    this.getUsers();
                    this.selectedItem = null;
                    this.$toasted.success(this.$t('toasts.user_deleted'),{
                        duration : 3000
                    });
                }
            })
        },
        changeUserForm(form){
            this.editUser(form).then(res=>{
                if(res.status){
                    this.getUsers();
                    this.$toasted.success(this.$t('toasts.user_updated'),{
                        duration : 3000
                    });
                    this.showPopup = false;
                }
            })
        },
        ...mapActions({
            getUsers:'contacts/getUsers',
            getUsersGroup:'contacts/getUsersGroup',
            showUser:'contacts/showUser',
            editUser:'contacts/editUser',
            removeUser:'contacts/removeUser',
            postSignUp:'auth/postSignUp',
        }),
        ...mapMutations({
            changeUser:'contacts/changeUser'
        })
    }
}